import { createEntityAdapter } from '@reduxjs/toolkit';
import { EmployeeResponsePrivate } from '@tests/types';

export const employeesAdapter = createEntityAdapter<EmployeeResponsePrivate<string>>();
